import { Row } from 'react-table';

import styles from './PortDetails.module.scss';
import { CountryFlag } from 'CountryFlag/CountryFlag';

import { PortTargetArrivalInfo } from 'ais-facade-api/api';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Icon, VesselIcon } from 'app/components';
import { useFormatMoment } from 'app/hooks/useFormatMoment';

export const shipCallsColumns = [
  {
    Header: <Icon name="s-ais" size="20px" color="#fff" />,
    accessor: 'type',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetArrivalInfo> }) => {
      return (
        <div className={styles.center_icon_cell}>
          <VesselIcon vessel={vessel} />
        </div>
      );
    },
  },
  {
    Header: 'MMSI',
    accessor: 'mmsi',
    cellClassName: `${styles.link}`,
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetArrivalInfo> }) =>
      typeof vessel.mmsi === 'number' ? (
        <Link to={`/vessels/${vessel.mmsi}`} className={styles.link}>
          {vessel.mmsi}
        </Link>
      ) : (
        <>&mdash;</>
      ),
    canSort: true,
    sortBy: 'MMSI',
  },
  {
    Header: 'Name',
    accessor: 'staticData?.name',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetArrivalInfo> }) => (
      <>
        {typeof vessel?.registryData?.name === 'string' ? (
          vessel.registryData.name
        ) : typeof vessel.staticData?.name === 'string' ? (
          vessel.staticData.name
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
    canSort: true,
    sortBy: 'NAME',
  },
  {
    Header: 'IMO',
    accessor: 'imo',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetArrivalInfo> }) => (
      <>
        {typeof vessel?.registryData?.imo === 'number' ? (
          vessel.registryData.imo
        ) : typeof vessel.staticData?.imo === 'number' ? (
          vessel.staticData.imo
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: 'Flag',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetArrivalInfo> }) => (
      <>
        {vessel?.meta?.countryName ? (
          <>
            {vessel.meta.countryCode && <CountryFlag countryCode={vessel.meta.countryCode?.toLocaleLowerCase()} />}
            {vessel.meta.countryName} ({vessel.meta.countryCode})
          </>
        ) : (
          <>&mdash;</>
        )}
      </>
    ),
  },
  {
    Header: <Icon name="catalog-fleet" size="16px" />,
    accessor: 'belongsToFleet',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetArrivalInfo> }) => (
      <>
        {vessel.belongsToFleet ? (
          <div className={styles.center_icon_cell}>
            <Icon name="catalog-fleet" size="16px" />
          </div>
        ) : (
          <></>
        )}
      </>
    ),
  },
  {
    Header: 'Type',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetArrivalInfo> }) => (
      <>{vessel.meta && vessel.meta.typeGroup ? vessel.meta.typeGroup : <>&mdash;</>}</>
    ),
  },
  {
    Header: 'ETA',
    accessor: 'eta',
    Cell: ({ row: { original: vessel } }: { row: Row<PortTargetArrivalInfo> }) => {
      const formatMoment = useFormatMoment();
      return <>{vessel?.voyage?.eta?.dt ? formatMoment(moment(vessel.voyage.eta.dt)) : undefined}</>;
    },
  },
];
